import { Serializable } from "../utilities/Serializable";

export class ProductCategory extends Serializable {
    uuid: string;
    code: string;
    description: string;
}


// WEBPACK FOOTER //
// ./src/app/models/ProductCategory.ts